// ═══════════════════════════════════════════════════
// ATR Reseller Hub — Centralized API Layer
// File: src/api/resellerApi.js
// ═══════════════════════════════════════════════════
 
const BASE_URL = 'https://atrmart.in/agro';

// ── Auth token helper ──
const getToken  = () => localStorage.getItem('reseller_token');
const setToken  = (t) => localStorage.setItem('reseller_token', t);
const clearAuth = () => { localStorage.removeItem('reseller_token'); localStorage.removeItem('reseller_user'); };
// ── Base fetch with auth headers ──
const apiFetch = async (endpoint, options = {}) => {
const token = getToken();
const headers = {
      'Content-Type': 'application/json',
    'Accept': 'application/json', 
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  }
  // 2. Add leading slash check to prevent double slashes or missing slashes
  const url = `${BASE_URL}${endpoint.startsWith('/') ? endpoint : '/' + endpoint}`;
  const res = await fetch(url, { ...options, headers });

  if (res.status === 401) { 
    clearAuth(); 
    if (window.location.pathname !== '/reseller') window.location.reload(); 
  }

  if (!res.ok) {
    const err = await res.json().catch(() => ({ message: 'Internal Server Error' }));
    throw new Error(err.message || err.error || 'Request failed');
  }
  return res.json();
};

export const authAPI = {
  sendOtp: (mobile) => apiFetch('/auth/send-otp', { method: 'POST', body: JSON.stringify({ mobile }) }),
  verifyOtp: (mobile, otp, name = null) =>
    apiFetch('/auth/verify-otp', { 
        method: 'POST', 
        body: JSON.stringify({ 
            mobile: mobile.toString(),
            otp: otp.toString(),    
            name: name || "" 
        }) 
    }),
  register: (data) => apiFetch('/auth/register', { method: 'POST', body: JSON.stringify(data) }),
  logout: () => apiFetch('/auth/logout', { method: 'POST' }).finally(clearAuth),
  getMe: () => apiFetch('/auth/me'),
};

// ══════════════════════════════
// DASHBOARD
// ══════════════════════════════
// --- resellerapi.js ---
export const dashboardAPI = {
    // CHANGE THIS: Add '/reseller' to the start of the path
    getStats: () => apiFetch('/reseller/dashboard/stats'),
    getRecentSales: () => apiFetch('/reseller/dashboard/recent-sales'),
    getLeaderboard: () => apiFetch('/reseller/dashboard/leaderboard'), 
};
// ══════════════════════════════
// CATALOG
// ══════════════════════════════
export const catalogAPI = {
  // Updated with /reseller prefix to match your dashboard/wallet logic
  getCategories: () => apiFetch('/categories'), 

  getProducts: (categoryId = null) => {
    // If categoryId is 1, the URL becomes: https://atrmart.in/api/reseller/catalog?category_id=1
    const endpoint = categoryId 
      ? `/catalog?category_id=${categoryId}` 
      : '/catalog';
    return apiFetch(endpoint);
  },

  generateShareLink: (id) => apiFetch(`/catalog/${id}/share-link`, { method: 'POST' }),
};
// ══════════════════════════════
// NETWORK / SALES
// ══════════════════════════════
// Change this in resellerapi.js
// --- resellerapi.js ---

export const networkAPI = {
    getSummary: () => apiFetch('/reseller/network/summary'),
    getSales: () => apiFetch('/reseller/network/sales'),
    
    // ADD THIS LINE to fix the current crash:
    getSalesHistory: () => apiFetch('/reseller/network/sales-history'), 
    
    // Also add this to prevent the next potential error:
    getDownline: () => apiFetch('/reseller/network/downline'),
};
// ══════════════════════════════
// WALLET & EARNINGS
// ══════════════════════════════
export const walletAPI = {
  // Add '/reseller' before '/wallet'
  getBalance: () => apiFetch('/reseller/wallet/balance'),
  getTransactions: () => apiFetch('/reseller/wallet/transactions'),
  getBankDetails: () => apiFetch('/reseller/wallet/bank'),
};
// ══════════════════════════════
// MARKETING KIT
// ══════════════════════════════
export const marketingAPI = {
  getAssets: () => apiFetch('/marketing/assets'),
  getCaptions: () => apiFetch('/marketing/captions'),
};
// ══════════════════════════════
// SUPPORT
// ══════════════════════════════
export const supportAPI = {
  getTickets: () => apiFetch('/support/tickets'),
  submitTicket: (data) => apiFetch('/support/tickets', { method: 'POST', body: JSON.stringify(data) }),
  getFAQs: () => apiFetch('/support/faqs'),
};

// ── Export token helpers ──
export { getToken, setToken, clearAuth };